import TextArea from 'antd/es/input/TextArea';
import cN from 'classnames';
import { useEffect, useState } from 'react';
import _ from 'lodash-es';
import { ArrowRightOutlined } from '@pietra/icons';
import { useInterval, useWindowSize } from 'react-use';
import './index.less';
import Image from 'next/image';
import { STATIC_FILE_URL } from '@/shared/constants';

interface IProps {
  onClickSend: (input: string) => void;
  onClickCreateAccount: () => void;
  onClickBookDemo: () => void;
}

const CopilotEntrypoint = ({ onClickSend, onClickCreateAccount, onClickBookDemo }: IProps) => {
  const { width } = useWindowSize();
  const useMobileLayoutCards = width <= 640;

  const [askAiInput, setAskAiInput] = useState<string>();
  const [_, setPlaceholderTextIndex] = useState<number>(0);
  const [placeholderText, setPlaceholderText] = useState<string>('');

  const sendBtnDisabled = !askAiInput?.trim()?.length;

  const placeholderTextValues = [
    'e.g., What work can I take off your plate?',
    'e.g., Can you help me find suppliers to create a product?',
    'e.g., Can you help me find influencers to promote my business?',
    'e.g., Can you help me research trends and decide what product to launch next?',
    'e.g., Can you help me find new customer segments I should market to?',
    'e.g., Can you help me create new content to post on social?',
  ];

  const typePlaceholder = (text: string) => {
    setPlaceholderText('');
    for (let i = 0; i < text.length; i++) {
      setTimeout(() => {
        setPlaceholderText(text.slice(0, i + 1));
      }, i * 30);
    }
  };

  useEffect(() => {
    const firstText = placeholderTextValues[0];
    const timer = setTimeout(() => typePlaceholder(firstText), 300);
    return () => clearTimeout(timer);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useInterval(() => {
    setPlaceholderTextIndex((prevIndex) => {
      const nextIndex = (prevIndex + 1) % placeholderTextValues.length;
      typePlaceholder(placeholderTextValues[nextIndex]);
      return nextIndex;
    });
  }, 4000);

  const renderValueProps = () => {
    if (useMobileLayoutCards) {
      return (
        <div className="value-props">
          <Image
            className="value-prop one mobile"
            src={`${STATIC_FILE_URL}/3bf0c06707a78d192325e269cc50912b.png`}
            alt="Find and contact factories"
            width={140}
            height={140}
          />
          <Image
            className="value-prop two mobile"
            src={`${STATIC_FILE_URL}/d4b0f19bdce0b4ec1462f602f1e8ba28.png`}
            alt="Find influencers"
            width={140}
            height={140}
          />
          <Image
            className="value-prop five mobile"
            src={`${STATIC_FILE_URL}/6a4fcf5f9685bffb34e2fca0e1f66c4c.png`}
            alt="Create assets"
            width={140}
            height={140}
          />
        </div>
      );
    } else {
      return (
        <div className="value-props">
          <Image
            className="value-prop one"
            src={`${STATIC_FILE_URL}/3bf0c06707a78d192325e269cc50912b.png`}
            alt="Find and contact factories"
            width={140}
            height={140}
          />
          <Image
            className="value-prop two"
            src={`${STATIC_FILE_URL}/d4b0f19bdce0b4ec1462f602f1e8ba28.png`}
            alt="Find influencers"
            width={140}
            height={140}
          />
          <Image
            className="value-prop three"
            src={`${STATIC_FILE_URL}/6a4fcf5f9685bffb34e2fca0e1f66c4c.png`}
            alt="Research trends"
            width={140}
            height={140}
          />
          <Image
            className="value-prop four"
            src={`${STATIC_FILE_URL}/31516b0491ffab546d76ad8abda5b8e4.png`}
            alt="Find customers"
            width={140}
            height={140}
          />
          <Image
            className="value-prop five"
            src={`${STATIC_FILE_URL}/6280087264dd24b955c488a8d82ea826.png`}
            alt="Create assets"
            width={140}
            height={140}
          />
        </div>
      );
    }
  };

  if (width === 0 || width === undefined) {
    return null;
  }

  return (
    <div className="copilot-entrypoint">
      {renderValueProps()}
      <div className="input">
        <div className="wrapper">
          <div className="text-area-wrapper">
            <TextArea
              placeholder={placeholderText}
              autoSize={{ minRows: 3, maxRows: 10 }}
              value={askAiInput}
              onChange={(e) => setAskAiInput(e.target.value)}
              onKeyDown={(e) => {
                if (e.key === 'Enter' && !e.shiftKey) {
                  e.preventDefault();
                  if (sendBtnDisabled) return;

                  onClickSend(askAiInput);
                }
              }}
            />
          </div>
          <div className="action-bar">
            <div style={{ flex: 1 }} />
            <div
              className={cN('start-copilot', {
                disabled: sendBtnDisabled,
              })}
              onClick={() => {
                if (sendBtnDisabled) return;

                onClickSend(askAiInput);
              }}
            >
              <ArrowRightOutlined style={{ color: '#fff' }} />
            </div>
          </div>
        </div>
      </div>
      <div className="create-account-button" onClick={onClickCreateAccount}>
        Get started for free <ArrowRightOutlined style={{ color: '#fff' }} />
      </div>
      <div className="book-demo-button" onClick={onClickBookDemo}>
        Book a demo
      </div>
    </div>
  );
};

export default CopilotEntrypoint;
